import { render } from "./ButtonsGroup.vue?vue&type=template&id=af5c1a6c&ts=true"
import script from "./ButtonsGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonsGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/conurse/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__